import { NetCommon, NetFront } from "@/constants/netEvent";
import { reqPost } from "@/service/clientRequest";
import {
  GetAwsS3PreSignUrlReq,
  GetAwsS3PreSignUrlRsp,
  UpdateAwsS3UploadResultReq,
} from "@/types/swagger/appserver";
import {
  EncryptStringReq,
  EncryptStringResp,
  GetIdxPoppupsReq,
  GetIdxPoppupsResp,
  UpdateIdxPoppupReadTimeReq,
  UpdateIdxPoppupReadTimeResp,
} from "@/types/swagger/common";

export interface GetUploadConfigRsp {
  file_count_limit: number;
  video_count_limit: number;
  content_size: number;
  support_type: {
    [key: string]: string;
  };
}

export const GetAwsS3PreSignUrl = (body: GetAwsS3PreSignUrlReq) => {
  return reqPost<GetAwsS3PreSignUrlReq, GetAwsS3PreSignUrlRsp>(
    body,
    NetFront.mod,
    NetFront.GetAwsS3PreSignUrl,
    true,
  );
};
export const UpdateAwsS3UploadResult = (body: UpdateAwsS3UploadResultReq) => {
  return reqPost<UpdateAwsS3UploadResultReq, UpdateAwsS3UploadResultReq>(
    body,
    NetFront.mod,
    NetFront.UpdateAwsS3UploadResult,
    true,
  );
};
export const GetUploadConfig = (data: { key: string }) => {
  return reqPost<{ key: string }, GetUploadConfigRsp>(
    data,
    NetFront.mod,
    "NA.GetUploadConfig",
    true,
  );
};
export const GetUploadUrl = (data: { key: string; content_type: string }) => {
  return reqPost<{ key: string }, { upload_url: string; file_key: string }>(
    data,
    NetFront.mod,
    "NA.GetUploadUrl",
    true,
  );
};
export const UpdateIdxPoppupReadTime = (body: UpdateIdxPoppupReadTimeReq) => {
  return reqPost<UpdateIdxPoppupReadTimeReq, UpdateIdxPoppupReadTimeResp>(
    body,
    NetCommon.mod,
    NetCommon.UpdateIdxPoppupReadTime,
    true,
  );
};
// 获取首页弹窗
export const GetIdxPoppups = (data: {
  data: GetIdxPoppupsReq;
  isNeedLogin: boolean;
}) => {
  return reqPost<GetIdxPoppupsReq, GetIdxPoppupsResp>(
    data.data,
    NetCommon.mod,
    NetCommon.GetIdxPoppups,
    data.isNeedLogin,
  );
};

export const GetEncryptString = (data: string) => {
  return reqPost<EncryptStringReq, EncryptStringResp>(
    { src: data },
    NetCommon.mod,
    NetCommon.EncryptString,
    false,
  );
};
